import React from 'react';
export function StickyBottomCTA() {
  return <div className="fixed bottom-0 left-0 right-0 bg-[var(--red2)] px-5 py-3.5 z-40" data-id="element-274">
      <a href="https://decidirconclaridad.com/checkouts/cn/hWNBUkgxufwmF4ZJiE9h80g6/es-us" target="_blank" rel="noopener noreferrer" className="block text-center font-bold text-[15px] tracking-wider text-white" data-id="element-275">
        ACTIVAR MI CÓDIGO ROJO — $17 USD →
      </a>
    </div>;
}